import { ModuleFE_BaseApi, ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
import { DBDef_UnresolvedCode, PermissionKeys_UnresolvedCodesUI } from '@app/runtime-tools-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend';
const dispatch_onUnresolvedCodeChanged = new ThunderDispatcher('__onUnresolvedCodeChanged');
export class ModuleFE_UnresolvedCode_Class extends ModuleFE_BaseApi {
    permissions;
    constructor() {
        super(DBDef_UnresolvedCode, dispatch_onUnresolvedCodeChanged);
        this.permissions = PermissionKey_FE.generatePermissionKeysByLevels(PermissionKeys_UnresolvedCodesUI);
    }
}
export const ModuleFE_UnresolvedCode = new ModuleFE_UnresolvedCode_Class();
//# sourceMappingURL=ModuleFE_UnresolvedCode.js.map